import {Component} from '@angular/core';
import {environment} from "../../../environments/environment";
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {ErrorService} from "../../services/error.service";

@Component({
  selector: 'app-blank-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent {
  googleLoading = false;
  authChecked = false;
  microsoftLoading = false;
  isAuthenticating = false;

  microsoftAuthEnabled = environment.microsoftAuthEnabled;
  googleAuthEnabled = environment.googleAuthEnabled;

  constructor(private readonly authService: AuthService,
              public router: Router,
              public errorService: ErrorService) {
    this.authService.authErrorMessage$.asObservable().subscribe((error) => this.errorService.errorMessage$.next(error));
    this.authService.authChecked.subscribe((checked) => {
      this.authChecked = checked;
    });
    this.authService.profileSubject.subscribe(({profile}) => {
      if (profile) {
        this.isAuthenticating = true;
      }
    });
  }

  googleAuth(): void {
    this.googleLoading = true;
    setTimeout(() => this.authService.signInWithGoogle().catch(() => this.googleLoading = false));
  }

  isSignInDisabled(): boolean {
    return this.googleLoading || this.microsoftLoading;
  }

  microsoftAuth(): void {
    this.microsoftLoading = true;
    setTimeout(() => {
      this.authService.signInWithMicrosoft()
        .catch(() => this.microsoftLoading = false);
    });
  }
}
